import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { SSRDataProvider } from '@/src/context/SSRContext';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

// @ts-ignore
const initialData = window.__INITIAL_DATA__ || null;

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <SSRDataProvider initialData={initialData}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </SSRDataProvider>
    </HelmetProvider>
  </React.StrictMode>
);

// Dispatch a custom event after React mounts so the prerenderer knows it's safe to capture the DOM
setTimeout(() => {
  document.dispatchEvent(new Event('custom-render-trigger'));
}, 500);

